module.exports = __webpack_public_path__ + "img/chat_history.b828d647.svg";